import api from '@/backend/apiConfig/apiConfig';

// import wenben from '@/assets/googleAds/wenben.png';
import baifenbi from '@/assets/googleAds/baifenbi.png';
import wenben from '@/assets/googleAds/wenben.png';
import shijian from '@/assets/googleAds/shijian.png';
import shuzi from '@/assets/googleAds/shuzi.png';
// import  '' from '@/assets/googleAds/ ''.png';
// import shuzi from '@/assets/googleAds/shuzi.png';

let list_1 = [
	{
		label: '消耗',
		value: 'costMicros',
		icon: shuzi,
	},
	{
		label: '展示次数',
		value: 'impressions',
		icon: shuzi,
	},
	{
		label: '点击次数',
		value: 'clicks',
		icon: shuzi,
	},
	{
		label: '点击率',
		value: 'ctr',
		icon: baifenbi,
	},
	{
		label: '点击均价',
		value: 'averageCpc',
		icon: shuzi,
	},
	{
		label: '转化次数',
		value: 'conversions',
		icon: shuzi,
	},
	{
		label: '转化率',
		value: 'conversionsFromInteractionsRate',
		icon: baifenbi,
	},
	{
		label: '转化均价',
		value: 'costPerConversion',
		icon: shuzi,
	},
];

let list_2 = [
	...list_1,
	{
		label: '页首展示次数百分比',
		value: 'topImpressionPercentage',
		icon: baifenbi,
	},
	{
		label: '绝对页首展示次数百分比',
		value: 'absoluteTopImpressionPercentage',
		icon: baifenbi,
	},
];

let settingList = [
	{
		previewApi: api.googleAds.customerMetricsPreview,
		api: api.googleAds.customerMetrics,
		key: 'day',
		name: '日期报告',
		dimension: [
			{
				label: '日期',
				value: 'date',
				isMain: true,
				icon: shijian,
				isSort: true,
			},
		],
		indicators: list_1,
		isSort: true,
		sortConfig: {
			orderList: ['date'],
			orderWay: 'asc',
		},
	},
	{
		previewApi: api.googleAds.inquiryMetricsPreview,
		api: api.googleAds.inquiryMetrics,
		key: 'inquiry',
		name: '询盘报告',
		dimension: [
			{
				label: '线索名称',
				value: 'inquiryName',
				isMain: true,
				icon: wenben,
			},
			{
				label: '线索类型',
				value: 'websiteTypeStr',
				icon: wenben,
			},
			{
				label: '提交时间',
				value: 'inquiryTimeStr',
				icon: shijian,
			},
			{
				label: '来源/媒介',
				value: 'source',
				icon: wenben,
			},
			{
				label: '设备',
				value: 'inquiryDevice',
				icon: wenben,
			},
			{
				label: '国家/地区',
				value: 'country',
				icon: wenben,
			},
			{
				label: '广告系列',
				value: 'adSeries',
				icon: wenben,
			},
			{
				label: '关键词',
				value: 'keyword',
				icon: wenben,
			},
			{
				label: '是否垃圾线索',
				value: 'inquiryStatusStr',
				icon: wenben,
			},
		],
		indicators: [],
		screen: [
			{
				label: '线索类型',
				key: 'type',
				value: [0, 1, 4, 2, 5, 7, 8],
				options: [
					{
						label: '表单询盘',
						value: 'all',
					},
					{
						label: '邮件询盘',
						value: 2,
					},
					{
						label: 'Messenger询盘',
						value: 5,
					},
					{
						label: 'FB表单询盘',
						value: 7,
					},
					{
						label: 'WhatsApp询盘',
						value: 8,
					},
				],
			},
		],
	},
	{
		previewApi: api.googleAds.campaignMetricsPreview,
		api: api.googleAds.campaignMetrics,
		key: 'advertisingSeries',
		name: '广告系列报告',
		dimension: [
			{
				label: '广告系列名称',
				value: 'name',
				isMain: true,
				icon: wenben,
			},
			{
				label: '类型',
				value: 'advertisingChannelType',
				icon: wenben,
			},
			{
				label: '状态',
				value: 'status',
				icon: wenben,
			},
			{
				label: '预算',
				value: 'amountMicros',
				icon: shuzi,
			},
			{
				label: '预算类型',
				value: 'explicitlyShared',
				bind: 'explicitlySharedStr',
				icon: wenben,
			},
		],
		indicators: list_2,
		screen: [
			{
				label: '广告系列类型',
				key: 'advertisingChannelType',
				value: ["'SEARCH'", "'DISPLAY'"],
				options: [
					{
						label: '搜索广告',
						value: "'SEARCH'",
					},
					{
						label: '展示广告',
						value: "'DISPLAY'",
					},
					{
						label: '购物广告',
						value: "'SHOPPING'",
					},
					{
						label: '酒店广告',
						value: "'HOTEL'",
					},
					{
						label: '视频广告',
						value: "'VIDEO'",
					},
					{
						label: '跨多渠道应用广告',
						value: "'MULTI_CHANNEL'",
					},
					{
						label: '本地广告',
						value: "'LOCAL'",
					},
					{
						label: '智能广告',
						value: "'SMART'",
					},
					{
						label: '效果最大化广告',
						value: "'PERFORMANCE_MAX'",
					},
				],
			},
			{
				label: '广告系列状态',
				key: 'status',
				value: ["'ENABLED'"],
				options: [
					{
						label: '已启用',
						value: "'ENABLED'",
					},
					{
						label: '已暂停',
						value: "'PAUSED'",
					},
					{
						label: '已删除',
						value: "'REMOVED'",
					},
				],
			},
		],
		isSort: true,
	},
	{
		previewApi: api.googleAds.geoMetricsPreview,
		api: api.googleAds.geoMetrics,
		key: 'countriesRegions',
		name: '国家/地区报告',
		dimension: [
			{
				label: '国家/地区',
				value: 'countryCriterionId',
				isMain: true,
				icon: wenben,
			},
			{
				label: '广告系列',
				value: 'campaignName',
				isMain: true,
				icon: wenben,
			},
		],
		indicators: [
			{
				label: '出价调整',
				value: 'bidModifier',
				icon: shuzi,
			},
			...list_1,
		],
		isSort: true,
	},
	{
		previewApi: api.googleAds.keywordMetricsPreview,
		api: api.googleAds.keywordMetrics,
		key: 'keywords',
		name: '关键词报告',
		dimension: [
			{
				label: '关键词',
				value: 'text',
				isMain: true,
				icon: wenben,
			},
			{
				label: '启用状态',
				value: 'status',
				icon: wenben,
			},
			{
				label: '匹配类型',
				value: 'matchType',
				icon: wenben,
			},
			{
				label: '广告系列',
				value: 'campaignName',
				icon: wenben,
			},
			{
				label: '广告组',
				value: 'adGroupName',
				icon: wenben,
			},
		],
		indicators: [
			...list_2,
			{
				label: '出价',
				value: 'cpcBidMicros',
				icon: shuzi,
			},
		],
		screen: [
			{
				label: '启用状态',
				key: 'status',
				value: ["'ENABLED'"],
				options: [
					{
						label: '已启用',
						value: "'ENABLED'",
					},
					{
						label: '已暂停',
						value: "'PAUSED'",
					},
					{
						label: '已删除',
						value: "'REMOVED'",
					},
				],
			},
			{
				label: '广告系列状态',
				key: 'campaignStatus',
				value: ["'ENABLED'"],
				options: [
					{
						label: '已启用',
						value: "'ENABLED'",
					},
					{
						label: '已暂停',
						value: "'PAUSED'",
					},
					{
						label: '已删除',
						value: "'REMOVED'",
					},
				],
			},
			{
				label: '广告组状态',
				key: 'adGroupStatus',
				value: ["'ENABLED'"],
				options: [
					{
						label: '已启用',
						value: "'ENABLED'",
					},
					{
						label: '已暂停',
						value: "'PAUSED'",
					},
					{
						label: '已删除',
						value: "'REMOVED'",
					},
				],
			},
		],
		isSort: true,
	},
	{
		previewApi: api.googleAds.searchTermMetricsPreview,
		api: api.googleAds.searchTermMetrics,
		key: 'searchTerm',
		name: '搜索词报告',
		dimension: [
			{
				label: '搜索词',
				value: 'searchTerm',
				isMain: true,
				icon: wenben,
			},
			{
				label: '匹配类型',
				value: 'searchTermMatchType',
				icon: wenben,
			},
			{
				label: '广告系列',
				value: 'campaignName',
				icon: wenben,
			},
			{
				label: '广告组',
				value: 'adGroupName',
				icon: wenben,
			},
			{
				label: '匹配关键词',
				value: 'text',
				icon: wenben,
			},
			{
				label: '添加状态',
				value: 'status',
				icon: wenben,
			},
		],
		indicators: list_2,
		isSort: true,
	},
	{
		previewApi: api.googleAds.customerMetricsPreview,
		api: api.googleAds.customerMetrics,
		key: 'network',
		name: '网络报告',
		dimension: [
			{
				label: '网络',
				value: 'adNetworkType',
				isMain: true,
				icon: wenben,
			},
			{
				label: '广告系列',
				value: 'campaignName',
				icon: wenben,
			},
		],
		indicators: list_1,
		screen: [
			{
				label: '广告系列状态',
				key: 'campaignStatus',
				value: ["'ENABLED'"],
				options: [
					{
						label: '已启用',
						value: "'ENABLED'",
					},
					{
						label: '已暂停',
						value: "'PAUSED'",
					},
					{
						label: '已删除',
						value: "'REMOVED'",
					},
				],
			},
		],
		isSort: true,
	},
	{
		previewApi: api.googleAds.customerMetricsPreview,
		api: api.googleAds.customerMetrics,
		key: 'equipment',
		name: '设备报告',
		dimension: [
			{
				label: '设备',
				value: 'device',
				isMain: true,
				icon: wenben,
			},
			{
				label: '广告系列',
				value: 'campaignName',
				icon: wenben,
			},
		],
		indicators: list_1,
		screen: [
			{
				label: '广告系列状态',
				key: 'campaignStatus',
				value: ["'ENABLED'"],
				options: [
					{
						label: '已启用',
						value: "'ENABLED'",
					},
					{
						label: '已暂停',
						value: "'PAUSED'",
					},
					{
						label: '已删除',
						value: "'REMOVED'",
					},
				],
			},
		],
		isSort: true,
	},
];

export let reportEnumeration = [
	'日期报告',
	'询盘报告',
	'广告系列报告',
	'国家/地区报告',
	'关键词报告',
	'搜索词报告',
	'网络报告',
	'设备报告',
];

export function getDefaultData(type) {
	let info = settingList[type - 1];
	let chooseMap = {};
	let default0rder = info.sortConfig || {
		orderList: ['impressions'],
		orderWay: 'desc',
	};
	if (info.screen) {
		info.screen.forEach(item => {
			chooseMap[item.key] = item.value;
		});
	}
	return {
		chooseMap,
		dimensionList: info.dimension.map(item => item.value),
		indexList: info.indicators ? info.indicators.map(item => item.value) : [],
		...default0rder,
	};
}

export default settingList;
